<template>
  <div class="modal pb-8">
    <div class="close cursor-pointer text-right pt-5 pr-5">
      <iconClose @click="$emit('close')"/>
    </div>
    <div class="modal-title mb-5">{{ $t('settings.cancelModal.title') }}</div>

    <loaderButton
      className="apply-btn btn btn--sm btn--warmPink"
      @click.stop.prevent="apply"
      :loading="cancelLoading"
    >
      <div>{{ $t('settings.cancelModal.apply') }} </div>
    </loaderButton>
  </div>
</template>

<script>
import toastr from '@/plugins/toastr';
import loaderButton from '@/components/base/loaderButton';
import iconClose from '@/static/custom-img/close.svg';

export default {
  components: {
    iconClose,
    loaderButton,
  },

  data () {
    return {
      cancelLoading: false,
    };
  },

  methods: {
    async apply () {
      if (this.cancelLoading) {
        return;
      }

      this.cancelLoading = true;
      await this.$store.dispatch({
        type: 'user/PURCHASE_CANCEL',
      });
      this.cancelLoading = false;

      toastr.success(this.$t('base.success'));

      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  padding-top: 30px;
  text-align: center;
}

.close {
  position: absolute;
  top: 0px;
  right: 0px;
}

.icon {
  width: 90px;
  height: 90px;
}

.modal-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;
  padding: 9px 0;
  margin: auto;
}

.apply-btn {
  font-weight: bold;
  font-size: 18px;
  line-height: 16px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.175px;
  color: #FFFFFF;
  padding: 14px;
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .modal {
    padding-bottom: 45px!important;
    background-size: 80px;
    background-position: 100% 100%;
  }

  .icon {
    width: 75px;
    height: 75px;
  }
  .modal-title {
    font-size: 14px;
    line-height: 11px;
  }
}
</style>
